import React, { Component } from 'react'
import styled from 'styled-components'

import PropTypes from 'prop-types'

import { above, below } from '../style/functions'
import Button from './button'
import carat from '../images/carat.svg'

const priceRangeOptions = [
	{ key: '', value: '价格区间' },
	{ key: '$2,000,000+', value: '$2,000,000+' },
	{ key: '$1,500,000 - $2,000,000', value: '$1,500,000 - $2,000,000' },
	{ key: '$1,200,000 - $1,500,000', value: '$1,200,000 - $1,500,000' },
	{ key: '$1,000,000 - $1,200,000', value: '$1,000,000 - $1,200,000' },
	{ key: '$900,000 - $1,000,000', value: '$900,000 - $1,000,000' },
	{ key: '$800,000 - $900,000', value: '$800,000 - $900,000' },
	{ key: '$700,000 - $800,000', value: '$700,000 - $800,000' },
	// { key: '$600,000 - $700,000', value: '$600,000 - $700,000' },
]

const numberOfBedroomsOptions = [
	{ key: '', value: '所希望的卧室数量' },
	{ key: 'Studio', value: '单身公寓' },
	{ key: '1 Bedroom', value: '一房' },
	{ key: '1 Bedroom + Study', value: '一房加书房' },
	{ key: '2 Bedroom', value: '2房' },
	{ key: '2 Bedroom + Study', value: '2房加书房' },
	{ key: '3 Bedroom', value: '3房' },
	{ key: '3 Bedroom + Study', value: '3房加书房' },
	{ key: 'Penthouse', value: '豪华顶层公寓' },
	{ key: 'CommercialorRetail', value: '零售商铺' },
]

const buyerTypeOptions = [
	{ key: '', value: '买家类型*' },
	{ key: 'INV', value: '投資家' },
	{ key: 'FHB', value: '住宅購入者 種類' },
	{ key: 'O/O', value: '继续购房者' },
	{ key: 'Downsizer', value: '大房换小房' },
]

const countryOptions = [
	{ key: '', value: '背景地区*' },
	{ key: 'Australia', value: '澳大利亚' },
	{ key: 'China', value: '中国' },
	{ key: 'China – Hong Kong', value: '中国香港' },
	{ key: 'India', value: '印度' },
	{ key: 'Indonesia', value: '印度尼西亚' },
	{ key: 'Japan', value: '日本' },
	{ key: 'Malaysia', value: '马来西亚' },
	{ key: 'Philippines', value: '菲律宾' },
	{ key: 'Singapore', value: '新加坡' },
	{ key: 'United Kingdom', value: '英国' },
	{ key: 'United States', value: '美国' },
	{ key: 'Vietnam', value: '越南' },
	{ key: 'Other', value: '其他' },
]

// const hearAboutUsOptions = [
//   { key: "", value: "您是通过什么渠道知道我们的？*" },
//   { key: "SMH", value: "悉尼先锋晨报 The Sydney Morning Herald" },
//   { key: "Wechat" , value: "微信"},
//   { key: "Realestate.com.au", value: "Realestate.com.au" },
//   { key: "Ethnic Papers", value: "中文报纸" },
//   { key: "Wentworth courier", value: "Wentworth courier" },
//   { key: "Southern courier", value: "Southern courier" },
//   { key: "Inner West Courier", value: "Inner West Courier" },
//   { key: "Facebook", value: "Facebook" },
//   { key: "Instagram", value: "Instagram" },
//   { key: "Website" , value: "网站" },
//   { key: "Apartments Developments", value: "公寓开发" },
//   { key: "Domain", value: "Domain" },
//   { key: "Other", value: "其他" }
// ];

const submissionStatuses = {
	success: '您的信息已提交。',
	failed: '信息提交失败，请稍后重试。',
}

class EnquiryForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			first_name: '',
			last_name: '',
			email: '',

			priceRange: '',
			numberOfBedrooms: '',
			hearAboutUs: '',
			buyerType: '',
			zip: '',
			country: '',
			error: {},
			submissionStatus: '',
		}
	}

	handleSubmit(e) {
		const { to } = this.props

		const utm_source = this.props.utm_source ? this.props.utm_source : ''
		const utm_campaign = this.props.utm_campaign ? this.props.utm_campaign : ''
		const utm_medium = this.props.utm_medium ? this.props.utm_medium : ''
		const _utm_content = this.props.utm_source || this.props.utm_campaign || this.props.utm_medium ? utm_source + ' ' + utm_medium + ' ' + utm_campaign : '';

		// salesforce hardcoded (salesforce is not used for new One Mastery site).
		// declared in  json mapping
		// const Campaign_ID = '70190000001nyLH'
		// const oid = '00D90000000cpQH'
		// const retURL = 'https://onemastery.com.au/#enquiry'
		// const debug = '1'
		// const debugEmail = 'ruben@efront.com.au'

		const {
			first_name,
			last_name,
			email,
			mobile,
			priceRange,
			hearAboutUs,
			numberOfBedrooms,
			buyerType,
			zip,
			country,
		} = this.state

		// const salesforceArray = {
		// 	Campaign_ID: Campaign_ID,
		// 	oid: oid,
		// 	retURL: retURL,
		// 	// debug: debug,
		// 	// debugEmail: debugEmail,
		// 	first_name: first_name,
		// 	last_name: last_name,
		// 	email: email,
		// 	mobile: mobile,
		// 	'00N9000000384oT': priceRange,
		// 	'00N9000000384oS': numberOfBedrooms,
		// 	'00N90000005zUtt': buyerType,
		// 	zip: zip,
		// 	'00N0o00000NMzzW': zip,
		// 	country: country,
		// 	'00N0o00000NMzzR': country,
		// 	'00N0o00000NdgQ3': utm_source,
		// 	'00N0o00000NMzmc': utm_medium,
		// 	'00N0o00000NMzmh': utm_campaign,
		// 	'00N0o00000NMzmm': _utm_content,
		// 	'00N0o00000NdgQ8': _utm_content,
		// }

		const values = {
			first_name,
			last_name,
			email,
			mobile,
			priceRange,
			hearAboutUs,
			numberOfBedrooms,
			buyerType,
			zip,
			country,
			utm_source,
			utm_campaign,
			utm_medium,
			_utm_content,
			// salesforceArray,
		}

		if (!this.validateForm()) {
			setTimeout(() => console.log(this.state.error), 1000)
			return false
		}

		fetch(to, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(values), // Doesn't send to Salesforce like the original site did (Mastery by Crown Group).
		})
			.then((res) => res.json())
			.then((json) => {
				if (json.errorMessage) {
					this.setState({ ...this.state, submissionStatus: 'failed' })
				} else {
					this.setState({ ...this.state, submissionStatus: 'success' })
				}
			})
			.catch((err) => this.setState({ ...this.state, submissionStatus: 'success' }))

		e.preventDefault()
	}

	onInputChange(e) {
		const name = e.target.name
		this.setState({ ...this.state, [name]: e.target.value })
	}

	validateForm() {
		const {
			first_name,
			last_name,
			email,
			mobile,
			priceRange,
			hearAboutUs,
			numberOfBedrooms,
			buyerType,
			zip,
			country,
		} = this.state
		let error = { ...this.state.error }
		let isValid = true
		if (!first_name) {
			error['first_name'] = '此处必须填写'
			isValid = false
		} else {
			error['first_name'] = ''
		}

		if (!last_name) {
			error['last_name'] = '此处必须填写'
			isValid = false
		} else {
			error['last_name'] = ''
		}

		// if (!priceRange) {
		// 	error['priceRange'] = '此处必须填写'
		// 	isValid = false
		// } else {
		// 	error['priceRange'] = ''
		// }

		if (!email || !this.validateEmail(email)) {
			error['email'] = '请提供一个有效的电子邮箱'
			isValid = false
		} else {
			error['email'] = ''
		}

		if (!mobile || !this.validateContactNumber(mobile)) {
			error['mobile'] = '请提供一个有效的电话号码'
			isValid = false
		} else {
			error['mobile'] = ''
		}

		// if (!numberOfBedrooms || numberOfBedrooms === numberOfBedroomsOptions[0].value) {
		// 	error['numberOfBedrooms'] = '请选择一个选项'
		// 	isValid = false
		// } else {
		// 	error['numberOfBedrooms'] = ''
		// }

		// if (!hearAboutUs || hearAboutUs === hearAboutUsOptions[0].value) {
		//   error["hearAboutUs"] = "请选择一个选项";
		//   isValid = false;
		// } else {
		//   error["hearAboutUs"] = "";
		// }

		if (!buyerType || buyerType === buyerTypeOptions[0].value) {
			error["buyerType"] = "请选择一个选项";
			isValid = false;
		} else {
			error["buyerType"] = "";
		}

		if (!country || country === countryOptions[0].value) {
			error["country"] = "请选择一个选项";
			isValid = false;
		} else {
			error["country"] = "";
		}

		if (!zip) {
			error["zip"] = "此处必须填写";
			isValid = false;
		} else {
			error["zip"] = "";
		}

		this.setState({
			...this.state,
			error,
		})

		return isValid
	}

	validateEmail(email) {
		var re = /(.+)@(.+){2,}\.(.+){2,}/
		return re.test(String(email).toLowerCase())
	}

	validateContactNumber(value) {
		return value.match(/\d/g).length === 10
	}

	render() {
		const { error, submissionStatus } = this.state
		const form = (
			<div className='form'>
				<div className='field'>
					<input
						name='first_name'
						type='text'
						placeholder='名*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.first_name && <span className='error-text'>{error.first_name}</span>}
				</div>
				<div className='field'>
					<input
						name='last_name'
						type='text'
						placeholder='姓*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.last_name && <span className='error-text'>{error.last_name}</span>}
				</div>
				<div className='field'>
					<input
						name='email'
						type='text'
						placeholder='电子邮件*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.email && <span className='error-text'>{error.email}</span>}
				</div>
				<div className='field'>
					<input
						name='mobile'
						type='tel'
						placeholder='手机号码*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.mobile && <span className='error-text'>{error.mobile}</span>}
				</div>
				<div className='field select-field'>
					<select
						name='priceRange'
						value={this.state.priceRange}
						onChange={this.onInputChange.bind(this)}
					>
						{priceRangeOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.priceRange && <span className='error-text'>{error.priceRange}</span>}
				</div>
				<div className='field select-field'>
					<select
						name='numberOfBedrooms'
						value={this.state.numberOfBedrooms}
						onChange={this.onInputChange.bind(this)}
					>
						{numberOfBedroomsOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.numberOfBedrooms && (
						<span className='error-text'>{error.numberOfBedrooms}</span>
					)}
				</div>
				{/* <div className="field select-field full">
				<select
					name="hearAboutUs"
					value={this.state.hearAboutUs}
					onChange={this.onInputChange.bind(this)}
				>
					{hearAboutUsOptions.map(option => (
					<option key={option.key} value={option.key}>{option.value}</option>
					))}
				</select>
				{error.hearAboutUs && <span className="error-text">{error.hearAboutUs}</span>}
				</div> */}

				<div className='field select-field'>
					<select
						name='country'
						value={this.state.country}
						onChange={this.onInputChange.bind(this)}
					>
						{countryOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.country && <span className='error-text'>{error.country}</span>}
				</div>

				<div className='field'>
					<input
						name='zip'
						type='text'
						placeholder='邮编*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.zip && <span className='error-text'>{error.zip}</span>}
				</div>

				<div className='field select-field'>
					<select
						name='buyerType'
						value={this.state.hearAboutUs}
						onChange={this.onInputChange.bind(this)}
					>
						{buyerTypeOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.buyerType && <span className='error-text'>{error.buyerType}</span>}
				</div>

				<div className='footer'>
					<Button onClick={this.handleSubmit.bind(this)}>立即注册</Button>
					<input name='utm_campaign' type='hidden' value={this.props.utm_campaign} />
					<input name='utm_source' type='hidden' value={this.props.utm_source} />
					<input name='utm_medium' type='hidden' value={this.props.utm_medium} />
				</div>
			</div>
		)

		return (
			<EnquiryFormWrapper id='enquiry'>
				<h2>立即注册</h2>
				<hr />
				{(!submissionStatus || submissionStatus === 'failed') && (
					<React.Fragment>
						<p className='h3'>请填写并提交下方表格，我们会即刻与您联系</p>
						{form}
					</React.Fragment>
				)}
				{submissionStatus === 'failed' && <p>{submissionStatuses.failed}</p>}
				{submissionStatus === 'success' && <p>{submissionStatuses.success}</p>}
			</EnquiryFormWrapper>
		)
	}
}

const EnquiryFormWrapper = styled.div`
	background: #f0f0f0;
	padding: 5rem 12%;

	h2 {
		text-align: center;
		text-transform: uppercase;
		font-style: normal;
		padding: 0;
	}

	hr {
		margin: 1.75rem auto;
	}

	p {
		text-align: center;
	}

	.footer {
		flex: 0 0 100%;
		text-align: center;
		margin: 2rem 0 0;
	}

	.form {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin: 0 auto;
		max-width: 108rem;
	}

	.field {
		${above.tablet`
      float: left;
      width: 50%;

      :nth-child(odd) {
        float: left;
        padding-right: 0.5rem;

        &.select-field:after {
          right: 1.5rem;
        }
      }
      :nth-child(even) {
        float: right;
        padding-left: 0.5rem;
      }
    `}

		margin-bottom: 30px;

		&.full {
			width: 100%;
			padding: 0;

			&.select-field:after {
				right: 1rem;
			}
		}
	}

	.select-field {
		position: relative;

		:after {
			content: '';
			background: url(${carat}) no-repeat 50% 50%;
			background-size: contain;
			height: 1em;
			width: 1em;
			position: absolute;
			top: 1.5em;
			right: 1rem;
			margin-top: -0.5em;
		}
	}

	input,
	select {
		width: 100%;
		background: transparent;
		border-bottom: 1px solid currentColor;
		font-family: inherit;
		font-size: inherit;
		letter-spacing: inherit;
		color: inherit;
		text-transform: uppercase;
		height: 3rem;
		line-height: 3rem;
		opacity: 1;

		::placeholder {
			/* Chrome, Firefox, Opera, Safari 10.1+ */
			color: inherit;
			opacity: 1; /* Firefox */
		}

		:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: inherit;
		}

		::-ms-input-placeholder {
			/* Microsoft Edge */
			color: inherit;
		}
	}

	select {
		border-radius: 0px;
		-webkit-border-radius: 0px;
		-webkit-appearance: none;
		-moz-appearance: none;
		::-ms-expand {
			display: none;
		}
		background: transparent;
		background-repeat: no-repeat;
		background-position-x: 100%;
		background-position-y: -5px;
	}
	.error-text {
		color: #b96a51;
		font-size: 9pt;
		position: relative;
		top: 8px;
	}

	${below.tablet`
  .form {
    margin:0;
    > div{
      flex: 0 100%;
      input,
      select {
        width: 100%;
    }
  }
		`};
`

EnquiryForm.propTypes = {
	background: PropTypes.string,
	color: PropTypes.string,
	to: PropTypes.string.isRequired,
}

EnquiryForm.defaultProps = {
	background: '#0E434B',
	color: '#FFFFFF',
}

export default EnquiryForm
